module.exports = __webpack_public_path__ + "static/media/c1_6.c063e2b3.png";